<template>
  <div data-test="component-item">
    <!-- This field is used to pre-populate the form with default values based on component options stored in DB -->
    <div v-if="editable">
      <FormComponentSelect
        placeholder="Select Pre-Defined Component (if available) "
        :value="null"
        :formValue="{ components: [] }"
        :loadOptions="true"
        :config="{}"
        :emptyWhenNoSource="false"
        label="Select Component"
        @input="setComponentDefaults"
        @optionsLoaded="componentOptions = $event"
      />
    </div>
    <DynamicForm
      :formId="formId"
      :isNested="true"
      :editable="editable"
    />
    <AppButton
      v-if="editable"
      variant="danger"
      @click="$emit('delete')"
    >
      <AppIcon name="delete" /> Delete Component
    </AppButton>
  </div>
</template>

<script>
import _get from 'lodash/get'
import FormComponentSelect from '@/components/Forms/FormComponentSelect'
import useFormListNestedForm from './composables/useFormListNestedForm'
const { truncate } = require('@shared/utils/string')

export default {
  components: {
    FormComponentSelect,
    DynamicForm: () => import('@/components/DynamicForms/DynamicForm'),
  },
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
    iteration: {
      type: Number,
      default: 0,
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      componentOptions: [],
    }
  },
  setup (props, { root, emit }) {
    function customizeField (question) {
      const questionCustomized = {
        questionId: question.key,
        dataKey: question.key,
        placeholder: truncate(`Enter ${question.label}`, 26),
        ...question,
      }

      switch (question.questionId) {
        case 'preferredRoomFeatures':
          return {
            ...questionCustomized,
            config: {
              ...questionCustomized.config,
              options: _get(root.$store.getters['roomTemplate/roomTemplateQuestions'], 'features.config.options', []),
            },
          }
        default:
          return questionCustomized
      }
    }

    const {
      formId,
    } = useFormListNestedForm({ props, emit, customizeField, collection: 'components' })

    return {
      formId,
    }
  },
  methods: {
    setComponentDefaults (componentName) {
      const component = this.componentOptions.find(el => el.name === componentName)
      if (component) {
        if (component._id && (this.formValue.components || []).find(c => c.id === component._id)) {
          this.$store.dispatch('ui/showSnackbar', { text: 'Selected component already added', variant: 'error' })
        } else {
          this.$emit(
            'input',
            { ...this.value, id: component._id, code: component.code, name: component.name }
          )
        }
      }
    },
  },
}
</script>
